import React from 'react';
import {FormattedMessage} from 'react-intl';
import {config} from '@react-spring/web'
import useScrollTo from 'react-spring-scroll-to-hook';


export default function WETTabs(props) {

	const [className] = React.useState(props.className ? "tab-interface exclude-controls wb-tabs tabs-acc wb-init "+props.className : "tab-interface exclude-controls wb-tabs tabs-acc wb-init col-md-12");
	const [generatedIdObj] = React.useState(!!props.id ? {generatedId: props.id} : {generatedId: "wb-auto-"+Math.floor((Math.random() * 100000000) + 1)});
	
	React.useEffect(() => {
		// Initialize the WET plugin(s)
		if (window.wb) {
			window.wb.add(".wb-tabs");
		}
	}, []);
	
	const hasValidationErrors = (validationSchema, errors) => {
		if (props.submitCount > 0) {
			for (const [key] of Object.entries(errors)) {
				if (key in validationSchema) {
					return true;
				}
			}
		}
		return false;
	}
	
	const hadSuccessfulSubmission = () => {
		
		if (props.submitCount > 0 && Object.keys(props.errors).length === 0 && props.isSubmitting) {
			return true;
		}
		
		return false;
	}

	const {scrollTo} = useScrollTo(config.molasses);	//<-- usage: https://github.com/TomasSestak/react-spring-scroll-to-hook
	
	return (
		<div id="tabsDiv" className="row" style={{opacity:1}}>
		  <div className={className} id={generatedIdObj.generatedId}>{/* I don't think we need  ref={el => this.el = el} here... maybe ref={tabsInnerDiv} ??? const tasInnerDiv = React.useRef(); ??? */}
			<ul className="generated" role="tablist" aria-hidden="false" aria-live="off">
				{props.tabs?.map(function(tab,index){
					return (
						<li className={(index===0 ? "active" : "")} role="presentation" key={"tab-li-"+index} style={hasValidationErrors(tab.validationSchema, props.errors) ? {backgroundColor:"#f2dede", borderColor: "#ebccd1", color: "#a94442"} : (tab.disabled && !hadSuccessfulSubmission() ? {backgroundColor:"#e3e3e3", borderColor: "#dedede"} : null)}>
							<a 
								tabIndex={(index===0 ? "0" : "-1")} 
								id={"tab-"+index+"-lnk"}
								role="tab" 
								aria-selected={(index===0 ? "true" : "false")} 
								aria-controls={"tab-"+index} 
								href={"#tab-"+index}
								style={tab.disabled && !hadSuccessfulSubmission() ? {color:"#a9a9a9"} : null}
								onClick={tab.disabled && !hadSuccessfulSubmission() ? (event) => {event.preventDefault(); event.stopPropagation(); return false;} : null}
							>
								{tab.enableTabNumbering ? <>{index+1}. </> : <></>}
								{tab.tabLabel}
							</a>
						</li>
					);
				})}
			</ul>
			<div className="tabpanels" style={{zIndex:"unset"}}>
				{props.tabs?.map(function(tab,index,arr){
					let elemGeneratedId = "wb-auto-"+Math.floor((Math.random() * 100000000) + 1)
					let tableId = document.getElementById('tabsDiv');
					return (
						<details 
							id={"tab-"+index} 
							key={"tab-"+index} 
							is="span" 
							role="tabpanel" 
							class={generatedIdObj.generatedId+"-grp fade "+(index!==0 ? "noheight out" : "in")}
							style={{zIndex:"unset"}}
							aria-hidden={(index===0 ? "false" : "true")}
							aria-labelledby={"tab-"+index+"-lnk"}
							open={(index===0 ? "open" : "")}
							data-url=""
						>
							<summary
								tabIndex={(index===0 ? "0" : "-1")}  
								className="wb-toggle tgl-tab wb-init wb-toggle-inited wb-details-inited" 
								data-testid={"tabIndexEvent-" +index}
								id={elemGeneratedId}
								role="tab" 
								aria-hidden={(index===0 ? "false" : "true")}
								aria-selected={(index===0 ? "true" : "false")} 
								aria-posinset={index+1} 
								aria-setsize="3" 
								data-toggle={'{"parent": "#'+generatedIdObj.generatedId+'", "group": ".'+generatedIdObj.generatedId+'-grp"}'}
								style={tab.disabled && !hadSuccessfulSubmission() ? {color:"#a9a9a9"} : null}
								onClick={tab.disabled && !hadSuccessfulSubmission() ? (event) => {event.preventDefault(); event.stopPropagation(); return false;} : null}
							>
								{tab.enableTabNumbering ? <>{index+1}. </> : <></>}
								{tab.tabLabel}
							</summary>
							<div className="tgl-panel" aria-hidden="false" aria-labelledby={elemGeneratedId} style={{zIndex:"unset"}}>
								{tab.tabContent}
								{index > 0 ? 
									<div className="form-group col-md-6 col-sm-6 col-xs-6 text-left hidden-sm hidden-xs">
										<button type="button" data-testid={"clickTabBtn-" + index}
											onClick={() => {
												clickTab(index-1); 
												scrollTo(tableId, document.getElementById('global-alerts-container') ? -document.getElementById('global-alerts-container').offsetHeight - 2 : 0);
											}}
											className="btn btn-primary"
										>
											<span className="glyphicon glyphicon-chevron-left"></span> 
											<FormattedMessage id="button.previous"/>
										</button>
									</div>
								: <></>
								}
								{index < arr.length-1 && (!arr[index+1].disabled || (!!arr[index+1].disabled && hadSuccessfulSubmission())) ?
									<div className={index === 0 ? "col-md-12 col-sm-12 col-xs-12 form-group text-right hidden-sm hidden-xs" : "col-md-6 col-sm-6 col-xs-6 form-group text-right hidden-sm hidden-xs"}>
										<button type="button"
											onClick={() => {
												clickTab(index+1); 
												scrollTo(tableId, document.getElementById('global-alerts-container') ? -document.getElementById('global-alerts-container').offsetHeight - 2 : 0);
											}}
											className="btn btn-primary"
										>
											<FormattedMessage id="button.next"/> 
											<span className="glyphicon glyphicon-chevron-right"></span>
										</button>
									</div>
								: <></>
								}
							</div>
						</details>
					);
				})}
			</div>
		  </div>
		</div>	
	);
}

export function clickTab(index) {
	if (window.document.getElementById("tab-"+index)?.firstChild.attributes.getNamedItem("aria-hidden").value === "true") {
		window.document.getElementById("tab-"+index+"-lnk").click();
	} else {
		window.document.getElementById("tab-"+index)?.firstChild.click();
	}
}